import * as React from 'react';
import ArrowCircularOutlined from './arrow-circular-outlined';
import ArrowCircularFilled from './arrow-circular-filled';
import type { IconCombinedProps } from './types';
const ArrowCircularCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowCircularFilled ref={ref} {...rest} />;
  }
  return <ArrowCircularOutlined ref={ref} {...rest} />;
});
export default ArrowCircularCombined;